define('responsive-gameday/controllers/LiveViewController',['require','exports','module','Responsive/controllers/ViewController','./PitchFXViewController','./PitchByPitchMatchupViewController','Responsive/util/renderComplete','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service'],function(require,exports,module){
    // Add private variables here
    var ViewController = require("Responsive/controllers/ViewController"),
        PitchFXViewController = require( './PitchFXViewController' ),
        PitchByPitchMatchupViewController = require( './PitchByPitchMatchupViewController' ),
        renderComplete = require("Responsive/util/renderComplete"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service");

    var renderers = null,
        Superclass;
    
    // Constructor
    function LiveViewController(type) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "live";

        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ViewController.spawn(LiveViewController).define({
        loadView : function(){
            Superclass.loadView.call(this);
            this.setClassName("LiveViewController");
            
            this.pitchFx=new PitchFXViewController();
            this.pitchbypitchMatchup=new PitchByPitchMatchupViewController(false);
            this.childViewControllers.push(this.pitchFx);
            this.childViewControllers.push(this.pitchbypitchMatchup);

            this.pitchFx.parentViewController = this;
            this.pitchbypitchMatchup.parentViewController = this;

        },
        draw : function(){
            var that=this;
            Superclass.draw.call(this);
            that.childViewControllers.forEach(function(vc){
                vc.viewWillAppear();
                that.getView().appendChild(vc.getView());
                vc.viewDidAppear();
            });
            this.offsetView = this.pitchbypitchMatchup.view;
            this.pitchFx.emitter.on("PitchFXLayerDrawn",function(){
                renderComplete(function(){
                    that.checkHeight();
                });
            })
        }
    });

    Superclass = LiveViewController.superclass;
    return LiveViewController;
});
